import { type DependencyList, useCallback } from 'react';
import produce, { type Draft } from 'immer';
import { getProjectOrDeploymentState, type ProjectOrDeploymentState, useProjectOrDeploymentState } from 'client/sections/sectionsUtils';

export const useComponentIDs = () =>
  useProjectOrDeploymentState((state) => state.document?.componentsWithValues.map((component) => component.stackComponentID) || []);

export const getComponent = (stackComponentID: number | null, pathname?: string) => {
  const state = getProjectOrDeploymentState(pathname);
  const component = state.getState().document?.componentsWithValues.find((component) => component.stackComponentID === stackComponentID);
  return component;
};

export const useComponent = (stackComponentID: number | null) =>
  useProjectOrDeploymentState((state) =>
    state.document?.componentsWithValues.find((component) => component.stackComponentID === stackComponentID)
  );

export const useComponentUpdate = <Callback extends (...args: any) => void | Promise<void>>(
  stackComponentID: number | null,
  callback: (state: Draft<NonNullable<ProjectOrDeploymentState['document']>['componentsWithValues'][number]>) => Callback,
  deps: DependencyList = []
) =>
  useCallback(
    (...args: Parameters<Callback>) =>
      getProjectOrDeploymentState().setState(
        produce((state: ProjectOrDeploymentState) => {
          const componentValues = state.document?.componentsWithValues.find((component) => component.stackComponentID === stackComponentID);
          if (!componentValues) return state;

          callback(componentValues)(...args);

          return state;
        })
      ),
    [stackComponentID, ...deps]
  );
